export default "__VITE_ASSET__c3bfa7f4__"